import React, { Component } from 'react'
import ModalBody from '../modalbody';
import { connect } from 'react-redux';
import { addImagePreview, removeImagePreview } from "../../actions"
import CloseModal from '../closemodal';

class ImagePreview extends Component {

    handleChange = (e) => {
        let files = e.target.files;
        if(files.length > 0){
            let images = [];
            for(let i =0; i < files.length; i++){
                images.push({
                    url: URL.createObjectURL(files[i]),
                    file: files[i]
                })
            }
            this.props.addImagePreview(images);
        }
        e.target.value = '';
    }

    render() {
        return (
            <ModalBody heading="Upload Images">
                <div className="container-fluid">
                    <div className="modalcon">
                        <div className="m-b-20">
                            <input type="file" onChange={this.handleChange}  multiple />
                        </div>
                        <div className="row">
                            {
                                this.props.images.map(img => 
                                    <div className="col-md-3 m-b-20" key={"imagepreview-" + img.id}>
                                        <div className="imagepreviewcon">
                                            <img className="imagepreview" src={img.url} alt="" />
                                            <div className="flex-center imagedelete">
                                                <button className="btn btn-link" onClick={() => this.props.removeImagePreview(img.id)}>
                                                    <i className="fas fa-times-circle"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="modalfooter">
                        <CloseModal name={"Ok"} btnType="btn-pad btn-primary"/>
                    </div>
                </div>
            </ModalBody>
        )
    }
}

const mapStateToProps = (state) => ({
    images: state.imagePreview
})

const mapDispatchToProps = { addImagePreview, removeImagePreview }

export default connect(mapStateToProps, mapDispatchToProps)(ImagePreview)